export const NEW_ORDER_SUCCESS = 'NEW_ORDER_SUCCESS';
export const NEW_ORDER_PRODUCTS_SUCCESS = 'NEW_ORDER_PRODUCTS_SUCCESS';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_PLAN_ORDERS_SUCCESS = 'GET_PLAN_ORDERS_SUCCESS';
export const GET_AGREEMENT_SUCCESS = 'GET_AGREEMENT_SUCCESS';
export const GET_PHOTO_ORDERS_SUCCESS = 'GET_PHOTO_ORDERS_SUCCESS';
export const GET_UNBOOKED_ORDERS_SUCCESS = 'GET_UNBOOKED_ORDERS_SUCCESS';
export const GET_FILM_ORDERS_SUCCESS = 'GET_FILM_ORDERS_SUCCESS';
export const GET_ADVANCE_SEARCH_FILTERS_SUCCESS = 'GET_ADVANCE_SEARCH_FILTERS_SUCCESS';
export const GET_ADVANCE_SEARCH_ORDERS_SUCCESS = 'GET_ADVANCE_SEARCH_ORDERS_SUCCESS';
export const SAVE_ADVANCE_SEARCH_FILTER_SUCCESS = 'SAVE_ADVANCE_SEARCH_FILTER_SUCCESS';
export const SAVE_AGENT_BROKER_FILTERS_SUCCESS = 'SAVE_AGENT_BROKER_FILTERS_SUCCESS';
export const CHECK_IF_ORDER_IS_ARCHIVED_SUCCESS = 'CHECK_IF_ORDER_IS_ARCHIVED_SUCCESS';
export const SAVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS = 'SAVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS';
export const REMOVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS = 'REMOVE_ORDER_COMMAND_FOR_BOOKING_SUCCESS';
